import { useLocation } from "react-router-dom";

const TOOL_ROUTES = ["/bulk", "/discover", "/pipeline"];

export const Footer = () => {
  const { pathname } = useLocation();
  const isTool = TOOL_ROUTES.some(r => pathname.startsWith(r));

  if (isTool) {
    return (
      <footer style={{ borderTop: "1px solid #e5e7eb", marginTop: "8rem", backgroundColor: "#ffffff" }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-sm" style={{ color: "#6b7280" }}>
          <div>
            <div className="flex items-center gap-2 mb-3">
              <img src="/logo-light-bg.png" alt="The Managerly" className="h-7 w-auto" />
            </div>
            <p className="leading-relaxed">We rebuild the websites of London's best-kept secrets.</p>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] mb-3" style={{ color: "#9ca3af" }}>Method</p>
            <ul className="space-y-1.5">
              <li>1 — Trawl Google Maps directly</li>
              <li>2 — Score weak web presence vs review strength</li>
              <li>3 — Redesign the site they should have</li>
              <li>4 — Pitch the owner</li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] mb-3" style={{ color: "#9ca3af" }}>Studio</p>
            <p>London E2 / SE15</p>
            <p>hello@the-managerly.com</p>
            <p className="mt-4 font-mono text-[10px]" style={{ color: "#d1d5db" }}>© {new Date().getFullYear()} The Managerly. Data via Google Maps.</p>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className="border-t border-white/10 mt-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-sm text-white/60">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <img src="/logo.png" alt="The Managerly" className="h-7 w-auto" />
          </div>
          <p className="leading-relaxed">
            We rebuild the websites of London's best-kept secrets. Real businesses, real reviews, redesigned in public.
          </p>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40 mb-3">Method</p>
          <ul className="space-y-1.5">
            <li>1 — Trawl Google Maps directly</li>
            <li>2 — Score weak web presence vs review strength</li>
            <li>3 — Redesign the site they should have</li>
            <li>4 — Pitch the owner</li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40 mb-3">Studio</p>
          <p>London E2 / SE15</p>
          <p>hello@the-managerly.com</p>
          <p className="mt-4 font-mono text-[10px] text-white/30">© {new Date().getFullYear()} The Managerly. Data via Google Maps.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
